// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-form-field { width: 100% }
.error {
   color: #d32f2f;
   font-size: 13px;
}
.mat-dialog-content {
   overflow: hidden;
   width: 400px;
}
@media screen and (max-width: 700px) {
   .mat-dialog-content{
      width: auto;
   }
}
::ng-deep .mat-button:hover .mat-button-focus-overlay{
    opacity: 0.04 !important;
 }
`, "",{"version":3,"sources":["webpack://./src/app/dms/onedrive/create-onedrive.component.css"],"names":[],"mappings":"AAAA,kBAAkB,YAAY;AAC9B;GACG,cAAc;GACd,eAAe;AAClB;AACA;GACG,gBAAgB;GAChB,YAAY;AACf;AACA;GACG;MACG,WAAW;GACd;AACH;AACA;IACI,wBAAwB;CAC3B","sourcesContent":[".mat-form-field { width: 100% }\n.error {\n   color: #d32f2f;\n   font-size: 13px;\n}\n.mat-dialog-content {\n   overflow: hidden;\n   width: 400px;\n}\n@media screen and (max-width: 700px) {\n   .mat-dialog-content{\n      width: auto;\n   }\n}\n::ng-deep .mat-button:hover .mat-button-focus-overlay{\n    opacity: 0.04 !important;\n }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
